import http from '@/utils/http';


export const EsportsTournamentList = (parameter) => {
  return http.request({
    url: '/v1/games/esports_tournament/list',
    method: 'get',
    params: parameter
  })
}



export const EditEsportsTournament = (parameter) => {
  return http.request({
    url: '/v1/games/esports_tournament/edit',
    method: 'post',
    data: parameter
  })
}